import { render } from "./LocationInfoViewCard.vue?vue&type=template&id=6236f099"
import script from "./LocationInfoViewCard.vue?vue&type=script&lang=js"
export * from "./LocationInfoViewCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__